var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "85px",
    viewBox: "0 0 60 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-lock-6869814") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-lock-6869814",
    fill: "#2D506D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.695,35.73 L55.304,35.73 C57.7181,35.73 59.6751,38.1441 59.6751,40.1011 L59.6751,80.5191 C59.6751,82.9332 57.7181,84.8902 55.304,84.8902 L4.695,84.8902 C2.2809,84.8902 0.3239,82.4761 0.3239,80.5191 L0.3239,40.1011 C0.3239,37.687 2.2809,35.73 4.695,35.73 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,0.3711 C24.0473,0.3711 18.563,2.6406 14.52,6.6875 C10.477,10.7305 8.2036,16.2148 8.2036,21.9335 L8.2036,33.6445 L18.0591,33.6445 L18.0591,21.9335 C18.035662,18.8163 19.2622,15.8163 21.4575,13.6015 C23.6567,11.3867 26.6489,10.1406 29.77,10.1406 C32.8872,10.1406 35.8794,11.3867 38.0786,13.6015 C40.2778,15.8163 41.5005,18.8163 41.477,21.9335 L41.477,33.6445 L51.3325,33.6445 L51.3325,21.9335 C51.3325,16.2147 49.063,10.7305 45.0161,6.6875 C40.9731,2.6406 35.4888,0.3711 29.7701,0.3711 L29.77,0.3711 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.721029e480c6700d30cdf3c4e8c7afd8.svg";
export { ForwardRef as ReactComponent };